import React from 'react';
import {setFilter} from '../../../../states/duck/pages/admin/shareholderStatusReducer/actions';
import {useSelector, useDispatch} from 'react-redux';
import {SForm} from '@styled/admin/manageShareholderPage';
import Button from '@components/button';
import Input from '@components/input';
import {useForm} from 'react-hook-form';
import inputIcons from '@components/icons/input';
import Section from '@components/section';
import {useTranslation} from 'react-i18next';

const optionStatus = [
  {value: 'all', label: 'Trạng thái'},
  {value: 'voted', label: 'Đã biểu quyết'},
  {value: 'notVote', label: 'Chưa biểu quyết'},
];
const optionStatusEn = [
  {value: 'all', label: 'Status'},
  {value: 'voted', label: 'Voted'},
  {value: 'notVote', label: 'Unvoted'},
];
const optionJoinTypes = [
  {value: 'all', label: 'Hình thức'},
  {value: 'none', label: 'Chưa checkin'},
  {value: 'authority', label: 'Ủy quyền'},
  {value: 'live', label: 'Trực tiếp'},
  {value: 'online', label: 'Trực tuyến'},
];
const optionJoinTypesEn = [
  {value: 'all', label: 'Form'},
  {value: 'none', label: "Haven't checked in"},
  {value: 'authority', label: 'Authorization'},
  {value: 'live', label: 'Direct'},
  {value: 'online', label: 'Online'},
];

const optionsAuthorityTypes = [
  {value: 'all', label: 'Tất cả'},
  {value: 'notAuthority', label: 'Cổ đông'},
  {value: 'authority', label: 'Nhận ủy quyền'},
];
const optionsAuthorityTypesEn = [
  {value: 'all', label: 'All'},
  {value: 'notAuthority', label: 'Shareholder'},
  {value: 'authority', label: 'Get authorization'},
];
//check in server/services/info line 400 (??)

const optionsActiveTypes = [
  {value: 'all', label: 'Trạng thái hoạt động'},
  {value: 'false', label: 'Không hoạt động'},
  {value: 'true', label: 'Đang hoạt động'},
];
const optionsActiveTypesEn = [
  {value: 'all', label: 'Operation Status'},
  {value: 'false', label: 'Inactive'},
  {value: 'true', label: 'Active'},
];
// const optionsSortBy = [
//   {value:"code", label:"SX theo Mã Cổ đông"},
//   {value:"sharesNumber", label:"SX theo CP sở hữu"},
//   {value:"sharesJoinNumber", label:"SX theo CP đã tham dự"},
// ]
// const optionsOrder = [
//   {value:"asc", label:" SX Tăng dần"},
//   {value:"desc", label:"SX Giảm dần"},
// ]
const Form = () => {
  const {t, i18n} = useTranslation();
  const dispatch = useDispatch();
  const filter = useSelector((state) => state.admin.shareholderStatus.filter);
  const {handleSubmit, register, control} = useForm();
  const onSubmit = (data) => {
    const {identityNumber, status, joinType, authority, online} = data;
    dispatch(
      setFilter({
        ...filter,
        identityNumber,
        joinType: joinType ? joinType.value : 'all',
        status: status ? status.value : 'all',
        pageNumber: 1,
        pageSize: 10,
        authority: authority ? authority.value : 'all',
        online: online ? online.value : 'all',
        sortBy: 'code',
        order: 'asc',
      }),
    );
  };
  return (
    <SForm>
      <Section header={t("Quản lý Cổ đông")}>
        <div className="module-content">
          <div className="search-wrapper">
            <div className="search-item">
              <Input.Text
                register={register('identityNumber')}
                wrapperProps={{
                  label: t('Họ tên/CMND/CCCD'),
                  icon: inputIcons.account,
                  height: '40px',
                }}
              />
            </div>
            <div className="search-item">
              <Input.Select
                name="status"
                control={control}
                selectProps={{
                  placeholder: t('Trạng thái'),
                  options:
                    i18n.language === 'vi' ? optionStatus : optionStatusEn,
                }}
              />
            </div>
            <div className="search-item">
              <Input.Select
                name="joinType"
                control={control}
                selectProps={{
                  placeholder: t('Hình thức'),
                  options:
                    i18n.language === 'vi'
                      ? optionJoinTypes
                      : optionJoinTypesEn,
                }}
              />
            </div>
            <div className="search-item">
              <Input.Select
                name="authority"
                control={control}
                selectProps={{
                  placeholder: t('Tất cả'),
                  options:
                    i18n.language === 'vi'
                      ? optionsAuthorityTypes
                      : optionsAuthorityTypesEn,
                }}
              />
            </div>
            <div className="search-item">
              <Input.Select
                name="online"
                control={control}
                selectProps={{
                  placeholder: t('Trạng thái hoạt động'),
                  options:
                    i18n.language === 'vi'
                      ? optionsActiveTypes
                      : optionsActiveTypesEn,
                }}
              />
            </div>
            <div className="search-item">
              <Button onClick={handleSubmit(onSubmit)}>
                {' '}
                {t('Tìm kiếm')}{' '}
              </Button>
            </div>
          </div>
        </div>
      </Section>
    </SForm>
  );
};
export default Form;
